import { render, staticRenderFns } from "./TifInspeccionFechas.vue?vue&type=template&id=131e3e72"
import script from "./TifInspeccionFechas.vue?vue&type=script&lang=js"
export * from "./TifInspeccionFechas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports